import { UnitLike } from 'src/lib/fliko/models/units/unit.data';
import { SortHelper } from 'src/app/shared/helpers/sort.helper';

export function unitComparator(a: UnitLike, b: UnitLike): number {
  const fieldComparator = (a: any, b: any) =>
    SortHelper.numeralStringComparator(
      SortHelper.numeralStringParser(a),
      SortHelper.numeralStringParser(b),
      new Intl.Collator('pl').compare
    );

  const fields: (keyof UnitLike)[] = ['street', 'blockNumber', 'number'];
  let value = 0;

  for (const k of fields) {
    const key = k as keyof UnitLike;
    value = fieldComparator(a[key], b[key]);

    if (value) return value;
  }

  return value;
}
